var _defs, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _path, _path2, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fce7f3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "np",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fda4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f472b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sp",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fbcfe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f9a8d4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#bg)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 46,
    fill: "none",
    stroke: "#f9a8d4",
    strokeWidth: 1.8,
    strokeOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 36,
    fill: "none",
    stroke: "#fbcfe8",
    strokeWidth: 1,
    strokeOpacity: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 6,
    x2: 50,
    y2: 13,
    stroke: "#f472b6",
    strokeWidth: 2.2,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 50,
    x2: 87,
    y2: 50,
    stroke: "#f9a8d4",
    strokeWidth: 1.5,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 94,
    x2: 50,
    y2: 87,
    stroke: "#f9a8d4",
    strokeWidth: 1.5,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 50,
    x2: 13,
    y2: 50,
    stroke: "#f9a8d4",
    strokeWidth: 1.5,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 50 L58 26 L50 36 L42 26 Z",
    fill: "url(#np)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 50 L42 74 L50 64 L58 74 Z",
    fill: "url(#sp)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 5.5,
    fill: "#fff0f5",
    stroke: "#f9a8d4",
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 2.5,
    fill: "#f472b6",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.66f7ec04867360f921240458f5700687.svg";
export { ForwardRef as ReactComponent };